import { render, staticRenderFns } from "./TransferOpenPoliciesModal.vue?vue&type=template&id=f74fb856&scoped=true"
import script from "./TransferOpenPoliciesModal.vue?vue&type=script&lang=ts"
export * from "./TransferOpenPoliciesModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74fb856",
  null
  
)

export default component.exports